{
  "header": "Latest bulletins",
  "impersonate": {
    "text": "Kenno user {{impersonator}}"
  },
  "buttons": {
    "moreBulletins": "More bulletins",
    "readBulletin": "Read bulletin"
  },
  "pendingOperations": {
    "description": "You started an operation but did not return to the resident pages from authentication. Complete the operation by confirming it, or reject it.",
    "identificationRequired": "Confirming the operation requires strong authentication. Identify yourself so that you can confirm the operation.",
    "terminationTitle": "Incomplete termination notice",
    "modificationTitle": "Incomplete contract modification",
    "continue": "Continue confirmation",
    "identify": "Authenticate",
    "reject": "Reject",
    "error": "Failed to load unconfirmed operations. Please try again later.",
    "rejectError": "Rejecting the operation failed. Please try again later."
  }
}
